import { Link2, Loader2, RotateCcw } from "lucide-react";
import { useState } from "react";
import { toast } from "sonner";
import { errText, papi } from "../portalApi";
import { STATUS, fdate, inr, shareUrl } from "./crmUtil";

const copy = async (t) => { try { await navigator.clipboard.writeText(t); return true; } catch { return false; } };

const ShareBtn = ({ h, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const on = h.share?.active;
  const act = async (active) => {
    setBusy(true);
    try {
      const r = await papi("post", "/crm/share", { row_id: h.row_id, active });
      if (active) toast.success((await copy(shareUrl(r.token))) ? "Tracking link copied — shows status only, no prices" : shareUrl(r.token));
      else toast.success("Link switched off — it no longer opens");
      onChanged();
    } catch (e) { toast.error(errText(e)); }
    setBusy(false);
  };
  return (
    <span className="inline-flex gap-1">
      <button onClick={() => act(true)} disabled={busy} className="inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs hover:bg-slate-50" data-testid={`crm-share-tracking-btn-${h.row_id}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <Link2 className="h-3 w-3" />} {on ? "Copy tracking link" : "Share tracking link"}</button>
      {on && <button onClick={() => act(false)} disabled={busy} className="rounded-md border border-rose-200 px-2 py-1 text-xs text-rose-700 hover:bg-rose-50" data-testid={`crm-share-off-btn-${h.row_id}`}>Switch link off</button>}
    </span>
  );
};

export const History = ({ c, readOnly, onReorder, onChanged }) => (
  <ol className="relative max-h-[480px] space-y-3 overflow-y-auto border-l-2 border-slate-100 pl-4">
    {c.history.map((h) => {
      const [label, cls] = STATUS[h.status] || STATUS.pending;
      return (
        <li key={h.key} className="relative" data-testid={`crm-order-history-row-${h.row_id}`}>
          <span className="absolute -left-[23px] top-1.5 h-3 w-3 rounded-full border-2 border-white bg-teal-500" />
          <div className="flex flex-wrap items-center gap-2 text-xs"><b className="text-slate-700">{fdate(h.date)}</b><span className={`rounded px-1.5 py-0.5 font-semibold ${cls}`}>{label}</span>
            <span className="text-slate-400">{h.mode}{h.tracking && ` · ${h.tracking}`}</span>{h.amount > 0 && <span className="ml-auto font-semibold">{inr(h.amount)}</span>}</div>
          <p className="mt-0.5 text-sm text-slate-700">{h.items.map((i) => `${i.medicine} × ${i.quantity}`).join(" · ")}</p>
          {!readOnly && <div className="mt-1.5 flex flex-wrap gap-1.5">
            <button onClick={() => onReorder(c, h)} className="inline-flex items-center gap-1 rounded-md border px-2 py-1 text-xs hover:bg-slate-50" data-testid={`crm-order-reorder-btn-${h.row_id}`}><RotateCcw className="h-3 w-3" /> Reorder</button>
            {h.status !== "cancelled" && <ShareBtn h={h} onChanged={onChanged} />}
          </div>}
        </li>);
    })}
    {!c.history.length && <p className="text-sm text-slate-400">No orders in the last 12 months.</p>}
  </ol>
);
